import styled, { withTheme } from 'styled-components';

import BaseButton from './base-button';


const PlainButton = styled(BaseButton)`
    &.btn {
        &.btn-primary, &.btn-primary:focus, &.btn-primary:active {
            padding:9px 15px !important;
            border-radius:0;
            outline:none !important;
            box-shadow:none !important;
            border:thin solid transparent;
            color: ${props => props.theme.$dark};
            font-family: ${props => props.theme['$font-family-sans-serif']};
            font-size: ${(props) => props.theme['$font-size-16']};
            background: transparent;
            .icon {
                width:16px;
                height:11px;
                display:inline-block;
                background-size: 16px 11px;
                margin:0 0 0 5px;
            }
            &:hover {
                border:thin solid ${props => props.theme.$border};
                background-color: ${props => props.theme.$brown};
                color: ${props => props.theme.$gold};
            }
        }
    
    }
`;

export default withTheme(PlainButton);
